/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LootBoxPlacementContext = {
    LOOTBOX_PAGE: 'LOOTBOX_PAGE',
    LOOTSHOP: 'LOOTSHOP',
    HUB_PAGE: 'HUB_PAGE',
    QUEST_REWARD: 'QUEST_REWARD',
    COCKPIT: 'COCKPIT',
    INLINE_PROMO: 'INLINE_PROMO'
} as const;
export type LootBoxPlacementContext = typeof LootBoxPlacementContext[keyof typeof LootBoxPlacementContext];


export function instanceOfLootBoxPlacementContext(value: any): boolean {
    for (const key in LootBoxPlacementContext) {
        if (Object.prototype.hasOwnProperty.call(LootBoxPlacementContext, key)) {
            if (LootBoxPlacementContext[key as keyof typeof LootBoxPlacementContext] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LootBoxPlacementContextFromJSON(json: any): LootBoxPlacementContext {
    return LootBoxPlacementContextFromJSONTyped(json, false);
}

export function LootBoxPlacementContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxPlacementContext {
    return json as LootBoxPlacementContext;
}

export function LootBoxPlacementContextToJSON(value?: LootBoxPlacementContext | null): any {
    return value as any;
}

export function LootBoxPlacementContextToJSONTyped(value: any, ignoreDiscriminator: boolean): LootBoxPlacementContext {
    return value as LootBoxPlacementContext;
}

